/**
 * Shared SAP Purchase Requisition item factory.
 * Used by both PR Create and PR Edit (and "Add Item" on each).
 *
 * `itemCategoryDefault` differs by page:
 *  - Create passes `null` (forces the user to pick a category)
 *  - Edit passes `''` (Standard Item)
 */
export const createNewItem = (itemNumber, itemCategoryDefault = null) => ({
  // ITEM OVERVIEW
  item_number: itemNumber,
  account_assignment_category: 'K',
  item_category: itemCategoryDefault,
  material_id: '',
  short_text: '',
  quantity: '',
  unit_of_measure: 'EA',
  delivery_date_category: 'D',
  delivery_date: '',
  material_group: '',
  plant: '',
  storage_location: '',
  purchasing_group: '',
  purchasing_organization: '',
  agreement_number: '',
  info_record_number: '',

  // ITEM DETAIL - Material Data
  desired_vendor: '',
  fixed_vendor: '',
  service_number: '',
  valuation_type: '',
  batch: '',
  manufacturer_part_number: '',

  // ITEM DETAIL - Delivery Address
  title: '',
  name: '',
  delivery_street_house_number: '',
  delivery_country: '',
  delivery_postal_code: '',

  // ITEM DETAIL - Personnel
  mrp_controller: '',
  contact_person: '',

  // ITEM DETAIL - Quantities & Dates
  request_date: '',
  release_date: '',
  closed: false,
  delivery_date_flexibility: '',

  // ITEM DETAIL - Valuation
  valuation_price: '',
  currency: 'USD',
  per_unit_uom: 'EA',
  estimated_unit_price: '',
  total_value: '',
  price_currency: 'USD',

  // ITEM DETAIL - Account Assignment
  gl_account: '',
  cost_center: '',
  asset_number: '',
  order_number: '',
  network: '',
  wbs_element: '',
  profit_center: '',
  co_area: '',
  company_code: '',

  // ITEM DETAIL - Control Indicators
  goods_receipt_required: true,
  invoice_receipt_required: true,
  notes: '',

  // Conversion Tracking
  po_number: '',
  po_item: '',
  quantity_ordered: 0,
});

export const EMPTY_MASTER_DATA = {
  documentTypes: [],
  itemCategories: [],
  accountAssignmentCategories: [],
  processingStatuses: [],
  releaseIndicators: [],
  materialGroups: [],
  purchasingOrgs: [],
  purchasingGroups: [],
  companyCodes: [],
  plants: [],
  storageLocations: [],
  materials: [],
  costCenters: [],
  glAccounts: [],
  vendors: [],
  controllingAreas: [],
  profitCenters: [],
  mrpControllers: [],
  valuationTypes: ['NEW', 'USED', 'IMPORT', 'EXPORT'],
  unitsOfMeasure: [],
  deliveryDateCategories: [
    { id: 'D', name: 'Day' },
    { id: 'W', name: 'Week' },
    { id: 'M', name: 'Month' },
  ],
  priorities: ['LOW', 'NORMAL', 'HIGH', 'URGENT'],
  currencies: ['USD', 'EUR', 'INR', 'GBP', 'JPY', 'CNY'],
};
